import {Form, Formik} from "formik";
import Button from "../../../components/Button";
import {TwoFactorAuthRecoveryData} from "../../../types/AuthCredentials";
import * as Yup from "yup";
import {TextField} from "../../../components/Form/Form";
import {useNavigate} from "react-router-dom";

// Types ----

type TwoFactorAuthRecoveryFormProps = {
  onSubmit: ({recovery_code}: TwoFactorAuthRecoveryData) => void
  onChange: () => void
}

// Component ----

const validationSchema = Yup.object().shape({
  recovery_code: Yup.string()
    .matches(/[A-Za-z\d]{10}-[A-Za-z\d]{10}/, 'Recovery code doesn\'t look right (example: 6BzhNgDQVW-Q3oTrpHsDd)')
    .required('A recovery code is required.'),
});

const initialValues: TwoFactorAuthRecoveryData = {
  recovery_code: '',
}

function TwoFactorAuthRecoveryForm({onSubmit, onChange}: TwoFactorAuthRecoveryFormProps) {
  const navigate = useNavigate();

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {formik => (
        <Form className="space-y-6" onChange={onChange}>
          <TextField
            id="recovery-code"
            name="recovery_code"
            label='Enter one of your recovery codes'
            autoComplete='off'
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand focus:border-brand sm:text-sm"
          />

          <div className='flex gap-3'>
            <Button
              type="button"
              disabled={formik.isSubmitting}
              color={Button.colors.WHITE}
              onClick={() => navigate('/two-factor')}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={formik.isSubmitting}
              showSpinner={formik.isSubmitting}
            >
              Sign in
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export {TwoFactorAuthRecoveryForm};